import { render, staticRenderFns } from "./FulfilmentSla.vue?vue&type=template&id=123252ff&"
import script from "./FulfilmentSla.vue?vue&type=script&lang=js&"
export * from "./FulfilmentSla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports